import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		return <div style={{}}>
			
			<img src={require('./img/googleLogo.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				height:32,
				width:"auto",
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
				fontSize:16,
			}}>
				<span style={{
					fontWeight:"bold"	
				}}>Add your account</span>
				<br/>
				<br/>
				<span style={{
					lineHeight: 1.8,					
				}}>Sign in to get the most out of your device.</span>
				<span style={{
					color:global.blue,
				
				}}> Learn more</span>
				
				<div style={{
					position:"absolute",
					top:128,
					width: 300,
					height: 28,
					
				}}>
					<span style={{
						fontSize: 16,
						
						width: "100%",
						
					}}> example@gmail.com </span>
					<div style={{
						width: "100%",
						height:1,
						position:"absolute",
						bottom:0,
						backgroundColor:"grey",
						opacity:0.3
					}}/>
					<br/>	
					<br/>	
					<br/>	
					<img src={require('../Comp/img/df.png')} style={{
						// width: 644/2.2,
						// height: 148/2.2
						marginLeft:-10
					}}/>
					{/* <span style={{
						fontSize: 16,
						color: "#D93025",
						width: "100%",
						
					}}> In the standard process this screen show up, but there is no need from you to fill this. </span>	 */}
				</div>
			</div>
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Google_userName.js